import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { songsBrewMessages as messages } from './songsBrewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole card; each part uses its own slice of it */
import styles from './SongsBrewHomeCard.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The "In every issue" column of the offer (design: songsbrew-promotion a1). Hidden on a phone. */
const SongsBrewIssueListComponent: React.FC = () => {
  const intl = useIntl();
  const items = useMemo(
    () => [messages.insideDeepDive, messages.insideNews, messages.insideReviews, messages.insidePlaylist],
    []
  );
  return (
    <div className={styles.issue}>
      <span className={styles.issueKey}>{intl.formatMessage(messages.insideTitle)}</span>
      <ol className={styles.issueList}>
        {items.map((item, index) => (
          <li key={item.id} className={styles.issueRow}>
            <span className={styles.issueNumber} aria-hidden="true">
              {String(index + 1).padStart(2, '0')}
            </span>
            {intl.formatMessage(item)}
          </li>
        ))}
      </ol>
    </div>
  );
};

export const SongsBrewIssueList = TypedMemo(SongsBrewIssueListComponent);
